import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminAwardsItem from "./AdminAwardsItem";
import { Link } from "react-router-dom";

function AdminAwards(props) {
  const [awardsData, setAwardsData] = useState();

  useEffect(() => {
    const fetchProjects = async () => {
      await axios
        .get("https://api.fprovidencia.com/Award_1/")
        .then(function (response) {
          // handle success
          setAwardsData(response.data);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    };

    fetchProjects();
  }, []);

  return (
    <div id="Awards" className="Admin__Main__Grid__Child">
      <div className="Admin__Section">
        <h1 className="Admin__Section__Title">
          Prémios, Destinções e Menções Nacionais e Internacionais
        </h1>

        <Link className="Admin__Section__New" to="/Admin/Dashboard/NewAward">
          <button>NOVO PRÉMIO</button>
        </Link>
      </div>
      <div className="Admin__Projects__Grid">
        {awardsData?.map((data, index) => (
          <AdminAwardsItem data={data} index={index} type={1} />
        ))}
      </div>
    </div>
  );
}

export default AdminAwards;
